import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

const MembershipCard = () => {
  const { user } = useAuth();
  const [flipped, setFlipped] = useState(false);

  const getTierGradient = (tier) => {
    const gradients = {
      silver: 'linear-gradient(135deg, #8e9eab 0%, #c0c0c0 50%, #8e9eab 100%)',
      gold: 'linear-gradient(135deg, #CDB688 0%, #d8b261 50%, #d8b261 100%)',
      prive: 'linear-gradient(135deg, #000000 0%, #1a1a1a 50%, #2d2d2d 100%)',
      scc: 'linear-gradient(135deg, #c41e3a 0%, #ff6b6b 50%, #c41e3a 100%)'
    };
    return gradients[tier?.toLowerCase()] || gradients.silver;
  };

  const membershipLevel = user?.membershipLevel?.toUpperCase() || 'SILVER';
  const tier = user?.membershipLevel?.toLowerCase() || 'silver';

  return (
    <div className="membership-card-container">
      <div 
        className={`membership-card ${flipped ? 'flipped' : ''}`}
        onClick={() => setFlipped(!flipped)}
        style={{
          background: getTierGradient(tier)
        }}
      >
        {/* Front of Card - View Membership Prompt */}
        <div className="card-front">
          <div className="card-front-content">
            <div className="card-logo">
              <span style={{fontSize: '20px', fontWeight: '700', letterSpacing: '2px'}}>IBV</span>
              <span style={{fontSize: '11px', fontWeight: '400', marginTop: '2px'}}>WEALTH CLUB</span>
            </div>

            <div className="membership-prompt">
              <h2 style={{fontSize: '18px', fontWeight: '700', marginBottom: '6px', letterSpacing: '1px'}}>
                VIEW MEMBERSHIP CARD
              </h2>
              <p style={{fontSize: '12px', opacity: '0.8', fontWeight: '400'}}>
                Tap to flip and see your details
              </p>
            </div>

            <div className="flip-indicator">
              <svg width="35" height="35" viewBox="0 0 40 40" fill="none">
                <path d="M20 10 L30 20 L20 30" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" opacity="0.6"/>
                <path d="M10 10 L20 20 L10 30" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" opacity="0.3"/>
              </svg>
            </div>
          </div>
        </div>

        {/* Back of Card - Membership Details */}
        <div className="card-back">
          <div className="card-magnetic-strip"></div>
          
          <div className="card-back-content">
            <div className="member-profile-section">
              <div className="member-photo">
                {user?.profilePicture ? (
                  <img 
                    src={user.profilePicture} 
                    alt={user.name || 'Member'} 
                    className="profile-image"
                  />
                ) : (
                  <img 
                    src="/images/default-profile.jpg" 
                    alt="Default profile" 
                    className="profile-image"
                  />
                )}
              </div>
              <div className="member-details">
                <div className="member-name">{user?.name || 'AI NEXGEN'}</div>
                <div className="member-tier">{membershipLevel} MEMBER</div>
              </div>
            </div>

            <div className="member-info-grid">
              <div className="info-box">
                <div className="info-label">MEMBER ID</div>
                <div className="info-value">{user?.membershipNumber || '1234 5678 9101'}</div>
              </div>
              <div className="info-box">
                <div className="info-label">MEMBER SINCE</div>
                <div className="info-value">{user?.memberSince || '12/25'}</div>
              </div>
            </div>

            <div className="member-barcode">
              <svg width="100%" height="50" viewBox="0 0 200 50">
                <rect x="10" y="5" width="3" height="40" fill="#333"/>
                <rect x="15" y="5" width="2" height="40" fill="#333"/>
                <rect x="20" y="5" width="4" height="40" fill="#333"/>
                <rect x="27" y="5" width="2" height="40" fill="#333"/>
                <rect x="32" y="5" width="5" height="40" fill="#333"/>
                <rect x="40" y="5" width="2" height="40" fill="#333"/>
                <rect x="45" y="5" width="3" height="40" fill="#333"/>
                <rect x="52" y="5" width="2" height="40" fill="#333"/>
                <rect x="57" y="5" width="4" height="40" fill="#333"/>
                <rect x="65" y="5" width="3" height="40" fill="#333"/>
                <rect x="72" y="5" width="2" height="40" fill="#333"/>
                <rect x="77" y="5" width="5" height="40" fill="#333"/>
                <rect x="85" y="5" width="2" height="40" fill="#333"/>
                <rect x="90" y="5" width="3" height="40" fill="#333"/>
                <rect x="97" y="5" width="2" height="40" fill="#333"/>
                <rect x="102" y="5" width="4" height="40" fill="#333"/>
                <rect x="110" y="5" width="2" height="40" fill="#333"/>
                <rect x="115" y="5" width="3" height="40" fill="#333"/>
                <rect x="122" y="5" width="5" height="40" fill="#333"/>
                <rect x="130" y="5" width="2" height="40" fill="#333"/>
                <rect x="135" y="5" width="4" height="40" fill="#333"/>
                <rect x="142" y="5" width="2" height="40" fill="#333"/>
                <rect x="147" y="5" width="3" height="40" fill="#333"/>
                <rect x="153" y="5" width="2" height="40" fill="#333"/>
                <rect x="158" y="5" width="5" height="40" fill="#333"/>
                <rect x="166" y="5" width="3" height="40" fill="#333"/>
                <rect x="172" y="5" width="2" height="40" fill="#333"/>
                <rect x="177" y="5" width="4" height="40" fill="#333"/>
                <rect x="185" y="5" width="2" height="40" fill="#333"/>
              </svg>
            </div>

            <div className="card-back-footer">
            
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MembershipCard;
